import { Gamepad } from 'excalibur';

export const controller = (gamepad: Gamepad) => {
    return {
        leftStick: {
            get x() {
                return gamepad.getAxes(0);
            },
            get y() {
                return gamepad.getAxes(1);
            },
            pressed: {
                get holding() {
                    return !!gamepad.getButton(10);
                },
                get pressed() {
                    return gamepad.wasButtonPressed(10);
                },
            },
        },
        rightStick: {
            get x() {
                return gamepad.getAxes(2);
            },
            get y() {
                return gamepad.getAxes(3);
            },
            pressed: {
                get holding() {
                    return !!gamepad.getButton(11);
                },
                get pressed() {
                    return gamepad.wasButtonPressed(11);
                },
            },
        },
        aOrCross: {
            get holding() {
                return !!gamepad.getButton(0);
            },
            get pressed() {
                return gamepad.wasButtonPressed(0);
            },
        },
        bOrCircle: {
            get holding() {
                return !!gamepad.getButton(1);
            },
            get pressed() {
                return gamepad.wasButtonPressed(1);
            },
        },
        xOrSquare: {
            get holding() {
                return !!gamepad.getButton(2);
            },
            get pressed() {
                return gamepad.wasButtonPressed(2);
            },
        },
        yOrTriangle: {
            get holding() {
                return !!gamepad.getButton(3);
            },
            get pressed() {
                return gamepad.wasButtonPressed(3);
            },
        },
        leftBumper: {
            get holding() {
                return !!gamepad.getButton(4);
            },
            get pressed() {
                return gamepad.wasButtonPressed(4);
            },
        },
        rightBumper: {
            get holding() {
                return !!gamepad.getButton(5);
            },
            get pressed() {
                return gamepad.wasButtonPressed(5);
            },
        },
        leftTrigger: {
            get holding() {
                return gamepad.getButton(6);
            },
            get pressed() {
                return gamepad.wasButtonPressed(6);
            },
        },
        rightTrigger: {
            get holding() {
                return gamepad.getButton(7);
            },
            get pressed() {
                return gamepad.wasButtonPressed(7);
            },
        },
        back: {
            get holding() {
                return !!gamepad.getButton(8);
            },
            get pressed() {
                return gamepad.wasButtonPressed(8);
            },
        },
        start: {
            get holding() {
                return !!gamepad.getButton(9);
            },
            get pressed() {
                return gamepad.wasButtonPressed(9);
            },
        },
        dpadUp: {
            get holding() {
                return !!gamepad.getButton(12);
            },
            get pressed() {
                return gamepad.wasButtonPressed(12);
            },
        },
        dpadDown: {
            get holding() {
                return !!gamepad.getButton(13);
            },
            get pressed() {
                return gamepad.wasButtonPressed(13);
            },
        },
        dpadLeft: {
            get holding() {
                return !!gamepad.getButton(14);
            },
            get pressed() {
                return gamepad.wasButtonPressed(14);
            },
        },
        dpadRight: {
            get holding() {
                return !!gamepad.getButton(15);
            },
            get pressed() {
                return gamepad.wasButtonPressed(15);
            },
        },
    };
};
